function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "up",
  d: "M8.616 4.266a1.242 1.242 0 0 1 1.73.19 1.203 1.203 0 0 1-.192 1.707L7.077 8.59a1.244 1.244 0 0 1-1.538 0L2.462 6.163a1.203 1.203 0 0 1-.192-1.707A1.242 1.242 0 0 1 4 4.266l2.308 1.822 2.308-1.822z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("use", {
  transform: "rotate(-180 6.308 6.429)",
  xlinkHref: "#up"
}));

var SvgArrowUp = function SvgArrowUp(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _ref, _ref2);
};

export default SvgArrowUp;


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrow-up.svg
// module id = 311
// module chunks = 0 1